export const HOTLINE = '18006608';
export const ZALO_CHAT_LINK = 'https://zalo.me/2749650043063337701';
